import Form from "@/shared/form/form";
import { useSavePost } from "./model/use-save-post";
import { PostFormView } from "@/modules/feed/features/save-post/ui/post-form-view";
import { usePostToEdit } from "@/modules/feed/features/save-post/model/use-post-to-edit";
import { FC } from "react";
import { useTranslations } from "use-intl";
import { useNotification } from "@/shared/feedback/notification";
import { useSendPostToModeration } from "@/modules/feed/features/send-post-to-moderation";
import { GeneratePostTitleProps } from "@/modules/ai/features/generate-post-title/generate-post-title";

type PostFormProps = {
  postId?: string;
  afterSubmit?: () => void;
  GeneratePostTitleButton?: FC<GeneratePostTitleProps>;
};

export function PostForm({
  postId,
  afterSubmit,
  GeneratePostTitleButton,
}: PostFormProps) {
  const t = useTranslations("PostForm");
  const notify = useNotification();
  const [form] = Form.useForm();
  const { save, loading } = useSavePost();
  const { sendToModeration, loading: sending } = useSendPostToModeration();
  const { initialValues } = usePostToEdit({ postId });

  return (
    <PostFormView
      disabled={loading || sending}
      form={form}
      initialValues={initialValues}
      onFinish={async (values, intent) => {
        const saved = await save(values);

        if (!saved) {
          return;
        }

        // серверного «сохранить и отправить» нет: связку из двух мутаций делает форма,
        // чтобы для автора это осталось одним нажатием
        if (intent === "moderation") {
          await sendToModeration(saved.id);
        } else {
          notify?.success({ message: t("Saved as draft") });
        }

        form.resetFields();
        afterSubmit?.();
      }}
      GeneratePostTitleButton={GeneratePostTitleButton}
    />
  );
}
